import { formatMinutes, getDelimitedString } from "@compass/core";
import { PdfReportCss, PdfReportDataDisplay, PdfReportHeader, PdfReportSignBox, getPdfReportSpacing } from "components";
import { MatchReportTimeCard, MatchReportTimeCardContributorRow } from "generated/openApi";

export const TimeCardHtml = (props: { report: MatchReportTimeCard }) => {
  const renderFilters = (contributorDetail: MatchReportTimeCardContributorRow) => {
    const dataDisplayLabelWidth = "300px";
    return (
      <div style={{ paddingBottom: getPdfReportSpacing("md") }}>
        <PdfReportDataDisplay
          label="Contributor"
          value={
            <>
              {contributorDetail.contributor?.lastName}, {contributorDetail.contributor?.firstName}
            </>
          }
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Title"
          value={contributorDetail.contributor?.currentTitle}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Employee ID"
          value={contributorDetail.contributor?.employeeIdentification}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Partner"
          value={getDelimitedString(
            contributorDetail.partners?.map((x) => {
              return x.name;
            }),
            ", "
          )}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Report Period"
          value={
            <>
              {props.report.dateFrom && new Date(props.report.dateFrom).toLocaleDateString()} to{" "}
              {props.report.dateTo && new Date(props.report.dateTo).toLocaleDateString()}
            </>
          }
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Status"
          value={props.report.reviewName}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Total Hours for this Contributor"
          value={formatMinutes(contributorDetail.durationInMinutesPerContributor)}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />
      </div>
    );
  };

  const renderCalendars = (contributorRow: MatchReportTimeCardContributorRow) => {
    return (
      <div style={{ paddingBottom: getPdfReportSpacing("md") }}>
        {contributorRow.calendarMonths?.map((calendarMonth) => {
          const calendarWeeks = calendarMonth.calendarDays
            ?.map((a, index) => ({ a, index }))
            .reduce((r, { a, index }) => {
              const group = Math.floor(index / 7);
              ((r[group] = r[group] || []) as any[]).push(a);
              return r;
            }, []);

          return (
            <div style={{ paddingBottom: getPdfReportSpacing("md") }}>
              <div style={{ fontSize: "22px", marginBottom: "5px" }}>{calendarMonth.monthName}</div>

              <table
                style={{
                  marginBottom: "10px",
                }}
              >
                <thead>
                  <tr>
                    <th>Sun</th>
                    <th>Mon</th>
                    <th>Tue</th>
                    <th>Wed</th>
                    <th>Thu</th>
                    <th>Fri</th>
                    <th>Sat</th>
                  </tr>
                </thead>

                <tbody>
                  {calendarWeeks?.map((calendarWeek: any[]) => {
                    return (
                      <tr>
                        {calendarWeek.map((calendarDay) => {
                          return (
                            <td width="1%">
                              <div style={{ height: "50px", textAlign: "center" }}>
                                {calendarDay.date && (
                                  <div
                                    style={{
                                      position: "relative",
                                      textAlign: "right",
                                      color: "dimgrey",
                                      fontSize: "13px",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {new Date(calendarDay.date).getDate()}
                                  </div>
                                )}

                                <div style={{ fontSize: "20px" }}>
                                  {calendarDay.durationInMinutes > 0 && formatMinutes(calendarDay.durationInMinutes)}
                                </div>
                              </div>
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {calendarMonth.contributorMatchRows && calendarMonth.contributorMatchRows.length > 0 && (
                <table>
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left" }}>Date</th>
                      <th style={{ textAlign: "left" }}>Service</th>
                      <th style={{ textAlign: "right" }}>Hours</th>
                    </tr>
                  </thead>

                  <tbody>
                    {calendarMonth.contributorMatchRows?.map((contributorMatchRow) => (
                      <tr>
                        <td style={{ textAlign: "left" }}>
                          {contributorMatchRow.date && new Date(contributorMatchRow.date).toLocaleDateString()}
                        </td>
                        <td style={{ textAlign: "left" }}>{contributorMatchRow.contributorMatchService}</td>
                        <td style={{ textAlign: "right" }}>{formatMinutes(contributorMatchRow.durationInMinutes)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              <div style={{ textAlign: "right" }}>
                <b>Total Monthly Hours:</b> {formatMinutes(calendarMonth.durationInMinutesMonthly)}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderSignArea = () => {
    return (
      <div>
        <PdfReportSignBox label="Signature/Initials" />
        <PdfReportSignBox label="Date" />
      </div>
    );
  };

  return (
    <>
      <PdfReportCss />
      <div>
        {props.report.contributorRows?.map((contributorRow) => (
          <div style={{ position: "relative", pageBreakAfter: "always" }}>
            <PdfReportHeader title={"Match Time Card Report"} tenantName={props.report.tenantName} />

            {renderFilters(contributorRow)}

            {renderCalendars(contributorRow)}

            {renderSignArea()}
          </div>
        ))}
      </div>
    </>
  );
};
